export interface RoleAttributes {
  id?: string;
  name: string;
}

// REVIEW: consider modeling as a property of User
export class Role {

  private granted: string[];
  private revoked: string[];

  constructor(private readonly attributes: RoleAttributes) {
    this.granted = [];
    this.revoked = [];
  }

  public get id() {
    return this.attributes.id;
  }

  public get name() {
    return this.attributes.name;
  }

  public get grantedUserIds(): ReadonlyArray<string> {
    return this.granted;
  }

  public get revokedUserIds(): ReadonlyArray<string> {
    return this.revoked;
  }

  public grantTo(userId: string): Role {
    this.granted.push(userId);
    return this;
  }

  public revokeFrom(userId: string): Role {
    this.revoked.push(userId);
    return this;
  }
}
